var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPtLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ace0ad5912"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.5 157.59375 L 769.5 157.59375 L 769.5 652.59375 L 40.5 652.59375 Z M 40.5 157.59375 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ace0ad5912)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffbd59",
    d: "M 40.5 566.191406 L 121.046875 652.113281 L 40.5 652.113281 Z M 446.5625 279.894531 L 357.527344 279.894531 C 365.75 292.699219 369.75 307.160156 369.75 322.851562 C 369.75 345.710938 361.097656 364.855469 345.035156 380.917969 C 328.972656 396.980469 309.828125 405.011719 287.589844 405.011719 L 40.5 405.011719 L 40.5 566.175781 L 121.046875 652.101562 L 122.660156 652.101562 L 122.660156 487.777344 L 287.589844 487.777344 C 332.679688 487.777344 371.601562 471.71875 403.726562 439.59375 C 436.472656 407.46875 451.910156 367.9375 451.910156 322.835938 C 451.910156 307.855469 450.117188 293.542969 446.5625 279.894531 Z M 40.5 157.921875 L 122.660156 240.703125 L 522.335938 240.703125 L 522.335938 652.113281 L 605.121094 652.113281 L 605.121094 240.703125 L 769.441406 240.703125 L 769.441406 157.921875 Z M 40.5 157.921875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPtLogo);
export default __webpack_public_path__ + "static/media/pt-logo.9ca04419563581cea4e5c454c6992efa.svg";
export { ForwardRef as ReactComponent };